import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Spinner } from '@/ui/components/spinner';

export const Route = createFileRoute('/_authed/go')({
  component: GoLayout,
  pendingComponent: GoPending,
});

function GoLayout() {
  return (
    <div className="bg-surface-2 h-svh grid place-items-center grow">
      <Outlet />
    </div>
  );
}

function GoPending() {
  return (
    <div className="bg-surface-2 h-svh grid place-items-center grow relative">
      <Spinner kind="inset" />
    </div>
  );
}
